// extracted by mini-css-extract-plugin
export const wrapper = "socials-module--wrapper--14Q3q";